import { Store } from '@src/application/store/store';
import { StateDefinition } from '@src/application/store/state-definition';
import { LegacyStore } from '@src/application/store/legacy-store-interface.ts';

const store = new Store({
    loginModal: new StateDefinition(null, false),
});

export default store as unknown as LegacyStore<Promise<any>|null>;
